import useSetDictateState from './hooks/internal/useSetDictateState';

export { useSetDictateState };
